import { render, staticRenderFns } from "./ResultTopic.vue?vue&type=template&id=c2e89b98"
import script from "./ResultTopic.vue?vue&type=script&lang=js"
export * from "./ResultTopic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports